import { requestAuth, request } from "common-frontend-components";
import { appConfig } from "../variables/appConfig";
export function callGetCategoriesAsync() {
    return request.get(`${appConfig.categoriesUrl}`)
        .then(data => data
        .sort((a, b) => (a.index || 0) - (b.index || 0)));
}
export function callCreateCategoryAsync(category) {
    return requestAuth.post(`${appConfig.categoriesUrl}`, category);
}
export function callEditCategoryAsync(categoryId, category) {
    return requestAuth.patch(`${appConfig.categoriesUrl}/${categoryId}`, category);
}
export function callDeleteCategoryAsync(categoryId) {
    return requestAuth.delete(`${appConfig.categoriesUrl}/${categoryId}`);
}
//# sourceMappingURL=categories.js.map